// 头部红人视频数据
export type Influencer = {
  id: string;
  name: string;
  handle: string;
  followers: string;
  category: string;
  intro: string;
  avatar: string;
  cover: string;
};

export const influencers: Influencer[] = [
  {
    id: 'in1',
    name: '阿柚探店',
    handle: '@ayou-tandian',
    followers: '1280万',
    category: '美食探店',
    intro: '走街串巷找宝藏小店，人均三五十吃到扶墙。',
    avatar:
      'https://readdy.ai/api/search-image?query=Portrait%20of%20friendly%20young%20chinese%20female%20food%20vlogger%20smiling%20in%20casual%20outfit%2C%20soft%20natural%20light%2C%20clean%20background%2C%20social%20media%20avatar%20photography&width=400&height=400&seq=in-avatar-01&orientation=squarish',
    cover:
      'https://readdy.ai/api/search-image?query=Cozy%20street%20food%20scene%20with%20steaming%20local%20snacks%20on%20wooden%20table%2C%20warm%20evening%20light%2C%20appetizing%20close%20up%2C%20food%20photography&width=800&height=450&seq=in-cover-01&orientation=landscape',
  },
  {
    id: 'in2',
    name: '老周说戏',
    handle: '@laozhou-film',
    followers: '960万',
    category: '影视解读',
    intro: '十年老剧评人，拆解镜头语言与剧情伏笔。',
    avatar:
      'https://readdy.ai/api/search-image?query=Portrait%20of%20thoughtful%20middle%20aged%20chinese%20man%20with%20glasses%20smiling%2C%20casual%20sweater%2C%20soft%20studio%20light%2C%20clean%20background%2C%20social%20media%20avatar%20photography&width=400&height=400&seq=in-avatar-02&orientation=squarish',
    cover:
      'https://readdy.ai/api/search-image?query=Dramatic%20film%20scene%20with%20cinema%20screen%20and%20film%20reel%20in%20foreground%2C%20moody%20warm%20tones%2C%20cinematic%20atmosphere%2C%20film%20criticism%20photography&width=800&height=450&seq=in-cover-02&orientation=landscape',
  },
  {
    id: 'in3',
    name: '柚子Vlog',
    handle: '@youzi-life',
    followers: '830万',
    category: '生活日常',
    intro: '记录真实的一天，把平凡日子过成电影。',
    avatar:
      'https://readdy.ai/api/search-image?query=Portrait%20of%20cheerful%20young%20chinese%20woman%20with%20long%20hair%20in%20bright%20room%2C%20natural%20smile%2C%20soft%20window%20light%2C%20clean%20background%2C%20social%20media%20avatar%20photography&width=400&height=400&seq=in-avatar-03&orientation=squarish',
    cover:
      'https://readdy.ai/api/search-image?query=Cozy%20morning%20lifestyle%20scene%20with%20coffee%20and%20open%20journal%20on%20wooden%20desk%2C%20soft%20sunlight%2C%20minimal%20aesthetic%2C%20lifestyle%20photography&width=800&height=450&seq=in-cover-03&orientation=landscape',
  },
  {
    id: 'in4',
    name: '炸毛动漫',
    handle: '@zamao-anime',
    followers: '1500万',
    category: '创意动画',
    intro: '用 3D 与手绘还原青春，每周一更创意短片。',
    avatar:
      'https://readdy.ai/api/search-image?query=Portrait%20of%20young%20creative%20chinese%20man%20with%20colorful%20hair%20and%20casual%20streetwear%2C%20playful%20expression%2C%20clean%20background%2C%20social%20media%20avatar%20photography&width=400&height=400&seq=in-avatar-04&orientation=squarish',
    cover:
      'https://readdy.ai/api/search-image?query=Colorful%20retro%20cartoon%20animation%20style%20scene%20with%20childhood%20playground%20and%20arcade%20games%2C%20vibrant%20neon%20colors%2C%20nostalgic%20creative%20artwork&width=800&height=450&seq=in-cover-04&orientation=landscape',
  },
];